<mat-dialog-content>
 <ng-content></ng-content>
</mat-dialog-content>
